export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-26-C-front-side-WEB-THUMB-65a54a53651cde282cb8f026d3a134e7.jpg";